import React from "react";
import { blogsdata } from "../blogs-data";
import "../customcss.css"

export default function BlogsPage() {
  return (
    <section>
      <div className="container h-100 mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <p>"This is from Blogs page"</p>
      <div className="container text-left justify-start px-10 py-10 mx-auto lg:px-40 ">
        <h1 className="text-3xl font-bold text-white">Blogs</h1>
        <div className="py-10">
          {blogsdata.map((blogsdata) => (
            <div classname="mb-10 flex text-left">
              <h1 className="font-bold tkblogtitle"> {blogsdata.title} </h1>
              <img className="tkblogimage" src={blogsdata.image} alt={blogsdata.alt}/>
              <p className="text-xs tkblogdate"> {blogsdata.date} </p>
              <p className="mb-10 tkblogcontent"> {blogsdata.content} </p>
            </div>
          ))}
          <a href="/blogsPage">Read more...</a>
        </div>
        </div>
      </div>
    </section>
  );
}
